import { useKyronQuery } from './kyronQuery';

type VoiceOption = { provider: string; id: string; sample_url: string; label: string };
export const useTTSVoiceOptions = () => useKyronQuery<VoiceOption[]>('/realtime_transcription/voice_options');
